module.exports = __webpack_public_path__ + "img/ppt.34897380.svg";